<template>
  <v-dialog v-model="dialog" class="ma-0 pa-0 ">
    <div class="pa-0 ma-0 back-white border-white">
      <v-row
        class="align-center d-flex ma-0 pa-0 pl-3 pt-3 justify-center back-556C96 pb-3"
      >
        <h3 class="color-white pl-1">발주 수정</h3>
      </v-row>
      <v-row class="ma-0 pa-3 pt-4 pl-5">
        <h4>{{ "현장명 : " + orderList.constructionName }}</h4>
      </v-row>
      <v-row class="ma-0  pl-3 pb-3 pl-5">
        <h4>발주 데이터를 수정해 주세요.</h4>
        <v-spacer />
        <v-btn
          color="#EEEEEE"
          class=" mr-5"
          width="150"
          height="40"
          @click="
            $router.push({
              name: 'Approval',
              params: { orderId: orderList.orderId },
            })
          "
          :disabled="viewerRole"
        >
          승인/히스토리
        </v-btn>
      </v-row>
      <v-row justify-center align-center class="ma-0 pa-5 pb-3">
        <v-simple-table class="width-100" fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="back-8ca9dd ">
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  발주차수
                </th>
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  부위
                </th>
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  동
                </th>
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  층
                </th>
                <th
                  class="text-center back-8ca9dd color-white border-right-white "
                  rowspan="2"
                >
                  부재
                </th>
                <th
                  class="text-center back-8ca9dd color-white  border-right-white"
                  rowspan="1"
                  :colspan="materialLength"
                >
                  규격(단위:TON)
                </th>
                <th
                  class="text-center back-8ca9dd color-white  border-right-white"
                  rowspan="2"
                >
                  합계수량
                </th>
              </tr>
              <tr>
                <th
                  class="text-center back-8ca9dd color-white border-top-white  border-right-white"
                  v-for="(material, index) in materialList"
                  :key="index"
                >
                  {{ material.rebar_name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="orderList">
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.orderName }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.partName }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.dong }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.floor }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center border-left-aaaaaa"
                >
                  {{ orderList.type }}
                </td>
                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center"
                  v-for="(value, index) in orderList.rebarList"
                  :key="index"
                >
                  <!-- 차후계정만 수정 활성화 -->
                  <input
                    v-if="isAdmin"
                    v-model.number="orderList.rebarList[index]"
                    class="pa-0 text-center border-aaaaaa w-50"
                    :disabled="!orderStatus"
                    type="number"
                    @focus="focusClear(orderList.rebarList[index], index)"
                  />
                  <span v-else> {{ orderList.rebarList[index] }}</span>
                </td>

                <td
                  class="border-right-aaaaaa border-bottom-aaaaaa text-center"
                >
                  {{ sum(orderList.rebarList).toFixed(3) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
      <v-row class="ma-0 justify-center pa-3">
        <v-btn
          color="#FFFFFF"
          class="btn-ff5b5a"
          width="150"
          height="40"
          v-if="orderStatus && userStatus"
          @click="approvalCancelDialogOn"
        >
          승인취소
        </v-btn>
        <v-btn
          color="#ff5b5a"
          class="color-white  ml-5"
          width="150"
          height="40"
          v-if="orderStatus"
          @click="deleteData"
        >
          삭제
        </v-btn>

        <v-btn
          color="#739EEC"
          class="color-white ml-5"
          width="150"
          height="40"
          v-if="orderStatus"
          @click="updateData"
        >
          수정완료
        </v-btn>
        <v-btn
          color="#EEEEEE"
          class=" ml-5"
          width="150"
          height="40"
          @click="dialog = false"
        >
          닫기
        </v-btn>
        <h4 v-if="!orderStatus">
          일부 출고되었거나 이미 출고가 완료된 상태입니다.
        </h4>
      </v-row>
    </div>
    <DialogText
      :textDialog="textDialog"
      :dialogStatus="dialogStatus"
      @dialogChange="
        textDialog = false;
        dialog = true;
      "
      @actioneMethods="actioneMethods"
    ></DialogText>
  </v-dialog>
</template>

<script>
import OrderApi from "@/api/OrderService";
import ApprovalApi from "@/api/ApprovalService";
import Commonality from "@/mixin/Commonality";
import DialogText from "@/components/DialogText";
export default {
  components: {
    DialogText,
  },
  mixins: [Commonality],
  data: () => ({
    orderList: [],
    orderTotalList: [],
    orderId: "",
    dialog: false,
    textDialog: false,
    dialogStatus: "approvalCancel",
  }),
  computed: {
    materialLength() {
      return this.materialList.length;
    },

    userInfo() {
      return this.$store.getters.getUserList;
    },

    userType() {
      return this.userInfo.roleType;
    },

    userStatus() {
      return this.userType == "시스템관리자" || this.userType == "현장관리자";
    },
    userStatus1() {
      return (
        this.userType == "시스템관리자" ||
        this.userType == "현장관리자" ||
        this.userType == "발주담당자"
      );
    },
    orderStatus() {
      return (
        (this.orderList.orderStatus != "미 출고" && this.userStatus) ||
        (this.orderList.orderStatus == "미 출고" && this.userStatus1)
      );
    },
    isAdmin() {
      return (
        this.userInfo?.accountName === "chahoo" &&
        this.userInfo?.companyName === "차후" &&
        this.userInfo?.roleType === "시스템관리자"
      );
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },
  async created() {
    this.$bus.$on("orderDetail", async (value) => {
      this.orderId = value;
      await this.reset();
      this.dialog = true;
    });
  },
  methods: {
    async actioneMethods() {
      if (this.dialogStatus == "approvalCancel") {
        await this.approvalCancel();
      }
      this.textDialog = false;
      await this.$bus.$emit("orderNavigationDuplicated");
    },
    /**
     *
     */
    approvalCancelDialogOn() {
      this.dialog = false;
      this.textDialog = true;
      this.dialogStatus = "approvalCancel";
    },
    //deleteDialogOn() {
    //  this.dialog = false;
    //  this.textDialog = true;
    //  this.dialogStatus = "delete";
    //},
    async approvalCancel() {
      let { data } = await ApprovalApi.approvalRollBack(this.orderId);
      if (data.success == "ok") {
        this.$bus.$emit("dialog", "승인 취소가 완료되었습니다.");
      } else this.$bus.$emit("dialog", "승인 취소에 실패하였습니다.");
    },
    focusClear(val, index) {
      if (val != 0) return;
      let list = [];
      for (let i = 0; i < this.orderList.rebarList.length; i++) {
        if (index != i)
          list.push(
            this.orderList.rebarList[i] == "" ? 0 : this.orderList.rebarList[i]
          );
        else list.push("");
      }
      this.orderList.rebarList = list;
    },

    async reset() {
      this.$bus.$emit("loadingStart");
      let datas = { orderId: this.orderId };
      let orderTempList = await OrderApi.orderDetail(datas);
      this.orderList = orderTempList.data.orderList;
      this.$bus.$emit("loadingEnd");
    },

    async deleteData() {
      let data = {
        orderId: this.orderList.orderId,
      };
      let returnData = await OrderApi.orderDelete(data);
      const isSuccess = returnData.data.success === "ok";
      let text;
      if (returnData.data.success == "ok")
        text = "발주데이터 삭제가 완료 되었습니다.";
      else text = `${returnData.data.message}`;
      this.$bus.$emit("dialog", text, isSuccess);
      if (isSuccess) {
        this.$bus.$emit("orderNavigationDuplicated");
      }
      this.dialog = false;
    },

    async updateData() {
      let tempList = [];
      for (let i = 0; i < this.orderList.rebarList.length; i++) {
        tempList.push({
          rebarName: this.materialList[i].rebar_name,
          rebarValue:
            this.orderList.rebarList[i] == ""
              ? 0
              : Number(this.orderList.rebarList[i]),
        });
        this.orderList.rebarList[i] =
          this.orderList.rebarList[i] == ""
            ? 0
            : Number(this.orderList.rebarList[i]);
      }

      let data = {
        constructionId: this.orderList.constructionId,
        orderId: this.orderList.orderId,
        orderName: this.orderList.orderName,
        partName: this.orderList.partName,
        dong: this.orderList.dong,
        floor: this.orderList.floor,
        type: this.orderList.type,
        rebarListData: tempList,
      };
      let returnData = await OrderApi.orderUpdate(data);
      let text;
      if (returnData.data.success == "ok")
        text = "발주데이터 입력이 완료 되었습니다.";
      else text = `${returnData.data.reason} 입니다`;
      this.$bus.$emit("dialog", text);
      this.$bus.$emit("orderNavigationDuplicated");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.w-50 {
  width: 50px;
}

.height-94 {
  height: 94px !important;
}

.span-setting1 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 130px;
  height: 38px;
  vertical-align: middle;
}

.span-setting2 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 216px;
  height: 38px;
  vertical-align: middle;
}
</style>
